import { useIntl } from 'react-intl';

import { LoyaltyUser } from 'state/loyalty/hooks/types';

export const useLoyaltyPoints = (loyaltyUser: LoyaltyUser) => {
  const currentPoints = loyaltyUser?.points || 0;
  const expirationDate = loyaltyUser?.pointsExpiryDateKey || '';
  const isNewPointsModel = !!loyaltyUser?.expirationBuckets?.length;
  let pointsToExpire = 0;

  // Check if new expiration model is available
  if (isNewPointsModel) {
    pointsToExpire = loyaltyUser.expirationBuckets?.[0]?.pointsToExpire;
  }

  const { formatDate, formatTime } = useIntl();
  const pointsExpirationDate = `${formatDate(expirationDate, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  })} - ${formatTime(expirationDate)}`;
  const hasExpirationDate = !!expirationDate;

  return {
    pointsExpirationDate: {
      formatted: pointsExpirationDate,
      raw: expirationDate,
    },
    currentPoints,
    pointsToExpire,
    isNewPointsModel,
    userHasExpiringPoints:
      hasExpirationDate && (isNewPointsModel ? pointsToExpire > 0 : currentPoints > 0),
  } as const;
};
